interface ApiResponse<T> {
  success: boolean;
  data: T | null;
  error: string | null;
}

let getTokenFn: (() => Promise<string | null>) | null = null;

export function setTokenGetter(fn: () => Promise<string | null>) {
  getTokenFn = fn;
}

export async function apiFetch<T>(path: string, options?: RequestInit): Promise<ApiResponse<T>> {
  const token = await getTokenFn?.();

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options?.headers as Record<string, string>)
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`/api${path}`, {
    ...options,
    headers
  });

  if (response.status === 401) {
    window.location.href = '/sign-in';
    return { success: false, data: null, error: 'Unauthorized' };
  }

  if (!response.ok) {
    const body = (await response
      .json()
      .catch(() => ({ error: `Request failed: ${response.status}` }))) as { error?: string };
    throw new Error(body.error ?? `Request failed: ${response.status}`);
  }

  return response.json() as Promise<ApiResponse<T>>;
}
